/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionSurveyDataResponse = {
    properties: {
        id: {
    type: 'number',
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        question: {
    type: 'string',
    isRequired: true,
},
        order: {
    type: 'number',
    isRequired: true,
},
        assignee: {
    type: 'number',
    isRequired: true,
},
        comment: {
    type: 'string',
},
        meet: {
    type: 'boolean',
    isRequired: true,
},
        skipQuestion: {
    type: 'boolean',
    isRequired: true,
},
    },
};